import React, { useState, useEffect } from 'react';
import './AgenticSupport.css';

const agenticIcon = require('../../common/images/IC_agentic_ai.svg');

const AgenticFloatingButton = ({ onClick }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [showHint, setShowHint] = useState(false);
    const [hasBeenSeen, setHasBeenSeen] = useState(false);

    // Auto-show the hint label after 3 seconds on first load
    useEffect(() => {
        const timer = setTimeout(() => {
            if (!hasBeenSeen) {
                setShowHint(true);
                setHasBeenSeen(true);
                // Auto-hide after 5 seconds
                setTimeout(() => setShowHint(false), 5000);
            }
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div
            className={`agentic-fab-container ${isHovered ? 'hovered' : ''} ${showHint ? 'show-hint' : ''}`}
            onMouseEnter={() => { setIsHovered(true); setShowHint(true); }}
            onMouseLeave={() => { setIsHovered(false); setShowHint(false); }}
            onClick={onClick}
            title=""
        >



            {/* Expandable label that slides out */}
            <div className={`agentic-fab-label ${showHint || isHovered ? 'expanded' : ''}`}>
                <span className="agentic-fab-label-text">AI Assistant</span>
                <span className="agentic-fab-label-sub">Ask anything</span>
            </div>

            {/* Main button */}
            <div className="agentic-fab-button">
                {/* Rotating gradient border */}
                <div className="agentic-fab-gradient-ring"></div>
                {/* Icon container */}
                <div className="agentic-fab-icon-wrap">
                    <img
                        src={agenticIcon.default || agenticIcon}
                        alt="Agentic AI"
                        className="agentic-fab-icon-img"
                    />
                </div>
                {/* Live status dot */}
                <div className="agentic-fab-status-dot"></div>
            </div>
        </div>
    );
};

export default AgenticFloatingButton;
